export default __webpack_public_path__ + "static/media/alert.7ce2f74c.svg";